import BaseType from "../BaseType";
import Guid from "../Guid";

export default class OutreachRequestClassGrade extends BaseType {
  OutreachRequestClassId: string = Guid.Empty;
  GradeId: string = "";
  NumStudents: number = 0;
}
